import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { cartOperations } from "../../state/ducs/cart";
import { globalOperations } from "../../state/ducs/globalState";

const HotDealsCard = (props) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Debug logging
  console.log('Product data:', props.productObj);
  console.log('Photo path:', props.productObj.photo);

  const detailsClickHandler = () => {
    props.setSelectedProductVendorName(props.productObj.vendor_name);
  }

  const addToCartHandler = () => {
    const other_vendor_products = props.cartItems.filter(item => 
      item.vendor_name !== props.productObj.vendor_name
    );

    if (other_vendor_products.length) {
      alert("You can order single vendor product only at a time");
      return;
    }
    detailsClickHandler();
    props.addToCart(props.productObj);
    props.showAddToCartModal();
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const getImageUrl = () => {
    if (!props.productObj.photo) {
      return "https://via.placeholder.com/300x300/f8f9fa/6c757d?text=No+Image";
    }
    
    // If photo already contains full URL
    if (props.productObj.photo.startsWith('http')) {
      return props.productObj.photo;
    }
    
    // Construct full URL
    const baseUrl = `${process.env.REACT_APP_PRODUCT_IMAGE_URL}/`;
    const fullUrl = baseUrl + props.productObj.photo;
    console.log('Constructed image URL:', fullUrl);
    
    // Test the URL directly
    const testImage = new Image();
    testImage.onload = () => console.log('✅ Image exists and loads:', fullUrl);
    testImage.onerror = () => console.log('❌ Image failed to load:', fullUrl);
    testImage.src = fullUrl;
    
    return fullUrl;
  };

  const calculateDiscount = () => {
    if (props.productObj.original_price && props.productObj.price) {
      const original = parseFloat(props.productObj.original_price);
      const current = parseFloat(props.productObj.price);
      return Math.round(((original - current) / original) * 100);
    }
    return Math.floor(Math.random() * 30) + 10; // Fallback random discount
  };

  const discount = calculateDiscount();

  return (
    <div 
      className="hot-deals-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Discount Badge */}
      <div className="discount-badge">
        <span className="discount-percent">-{discount}%</span>
        <div className="badge-flame">🔥</div>
      </div>

      {/* Product Image */}
      <div className="product-image-container">
        <Link onClick={detailsClickHandler} to={"/productDetails/" + props.productObj.id}>
          <div className={`image-wrapper ${imageLoaded ? 'loaded' : ''}`}>
            {!imageLoaded && !imageError && <div className="image-skeleton"></div>}
            <img
              src={getImageUrl()}
              alt={props.productObj.name || 'Product Image'}
              className="product-image"
              onLoad={() => {
                console.log('Image loaded successfully');
                setImageLoaded(true);
                setImageError(false);
              }}
              onError={(e) => {
                console.log('Image failed to load:', e.target.src);
                setImageError(true);
                setImageLoaded(true);
                // Don't change src here, let CSS handle the fallback
              }}
              style={{ 
                display: imageError ? 'none' : 'block',
                opacity: imageLoaded && !imageError ? 1 : 0
              }}
            />
            {imageError && (
              <div className="image-fallback">
                <div className="fallback-icon">📷</div>
                <div className="fallback-text">Image not available</div>
              </div>
            )}
          </div>
        </Link>

        {/* Quick Action Tools */}
        <div className={`quick-actions ${isHovered ? 'visible' : ''}`}>
          <button className="action-btn wishlist-btn" title="Add to Wishlist">
            <i className="fa fa-heart"></i>
          </button>
          <button className="action-btn compare-btn" title="Compare">
            <i className="fa fa-exchange"></i>
          </button>
          <button className="action-btn quick-view-btn" title="Quick View">
            <i className="fa fa-search"></i>
          </button>
        </div>
      </div>

      {/* Product Details */}
      <div className="product-details">
        {/* Rating */}
        <div className="rating-section">
          <div className="stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className="fa fa-star"></i>
            ))}
          </div>
          <span className="rating-count">(4.5)</span>
        </div>

        {/* Product Title */}
        <h3 className="product-title">
          <Link onClick={detailsClickHandler} to={"/productDetails/" + props.productObj.id}>
            {props.productObj.name.length > 50 
              ? props.productObj.name.substr(0, 50) + "..." 
              : props.productObj.name
            }
          </Link>
        </h3>

        {/* Price Section */}
        <div className="price-section">
          <div className="current-price">
            ৳{numberWithCommas(props.productObj.price)}
          </div>
          {props.productObj.original_price && (
            <div className="original-price">
              ৳{numberWithCommas(props.productObj.original_price)}
            </div>
          )}
        </div>

        {/* Add to Cart Button */}
        <button 
          onClick={addToCartHandler} 
          className="add-to-cart-btn"
        >
          <i className="fa fa-shopping-cart"></i>
          <span>{props.t("addc") || "Add to Cart"}</span>
        </button>
      </div>

      {/* Hot Deal Timer (Optional) */}
      <div className="deal-timer">
        <div className="timer-label">Deal ends in:</div>
        <div className="timer-display">
          <span>2d</span> : <span>14h</span> : <span>23m</span>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { cartItems: state.cart };
};

const mapDispatchToProps = {
  addToCart: cartOperations.addToCart,
  showAddToCartModal: globalOperations.showAddToCartModal,
  setSelectedProductVendorName: globalOperations.setSelectedProductVendorName,
};

export default connect(mapStateToProps, mapDispatchToProps)(HotDealsCard);